import { render, staticRenderFns } from "./MaterialGroupList.vue?vue&type=template&id=d31aedea&"
import script from "./MaterialGroupList.js?vue&type=script&lang=js&"
export * from "./MaterialGroupList.js?vue&type=script&lang=js&"
import style0 from "./MaterialGroupList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports